import script from "./ServiceTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceTable.vue?vue&type=script&setup=true&lang=js"

export default script